export enum RequestStatus{
    Pending = 'pending',
    Accepted = 'accepted',
    Rejected = 'rejected',
    Later= 'later'
}